import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'boolToYesNo',
  pure: false,
  standalone: false
})
export class BoolToYesNoPipe implements PipeTransform {
  constructor(public translate: TranslateService) {}

  transform(value: unknown | true | false): unknown | string {
    if (typeof value === 'boolean') {
      if (value) {
        return this.translate.instant('i18n.common.yes');
      }
      return this.translate.instant('i18n.common.no');
    }
    return value;
  }
}
